import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "user-name px-6 font-bold text-14px text-white"
};
import { computed } from 'vue';
import { useAuthStore, useProfileStore } from '../../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MenuItemUserName',
    props: {},
    emits: [
        'onDoAction',
    ],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var authStore = useAuthStore();
        var profileStore = useProfileStore();
        var onDoAction = function () {
            emit('onDoAction');
        };
        var isAuth = computed(function () {
            return authStore.isAuth;
        });
        var userName = computed(function () {
            return profileStore.name;
        });
        return function (_ctx, _cache) {
            return (isAuth.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_1, _toDisplayString(userName.value), 1))
                : _createCommentVNode("", true);
        };
    }
});
